import { ModuleWithProviders} from '@angular/core';
import {Routes, RouterModule } from '@angular/router';

import { OnCallRosterAddComponent } from './on-call-roster-add.component'

const ON_CALL_ROSTER_ADD_ROUTES: Routes = [{
    path: '', component: OnCallRosterAddComponent
}];

export const ON_CALL_ROSTER_ADD_ROUTING : ModuleWithProviders<any> = RouterModule.forChild(ON_CALL_ROSTER_ADD_ROUTES);